import styled from '@emotion/styled';

export const MarkerWrapper = styled.div<{ isSelected: boolean }>`
  position: relative;
  top: -6px;
  left: 0;
  z-index: ${p => (p.isSelected ? '1' : '')};
  width: 3rem;
  height: 3rem;
  cursor: pointer;
`;

export const MarkerIconWrapper = styled.div<{ isSelected: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  fill: ${({ isSelected, theme }) =>
    isSelected ? theme.colors.neutral.white100 : theme.colors.brand.green120};
  filter: drop-shadow(0 1px 3px rgb(0 0 0 / 30%));

  & > svg {
    width: 48px;
    height: 48px;
  }
`;

export const MapMarkerBox = styled.svg<{ isSelected: boolean }>`
  stroke: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.brand.green120 : theme.colors.neutral.white100};
  stroke-width: 2px;
`;

export const StationTypeIcon = styled.div<{ isSelected: boolean }>`
  position: absolute;
  top: 3px;
  left: 5px;
  z-index: 1;

  & > svg {
    fill: ${({ isSelected, theme }) =>
      isSelected ? theme.colors.brand.green120 : theme.colors.neutral.white100};
    width: 40px;
    height: 32px;
  }
`;
